class SourceUpdatesDailyPoint {
    constructor(
        public date: string = "",
        public newItemCount: number = 0,
        public jsonDataChangedItemCount: number = 0,
        public attributesChangedItemCount: number = 0,
        public recentAttributesChangedItemCount: number = 0,
        public affectedItemCount: number = 0
    ) {
        //
    }

    public static fromPOJO(data: any) {
        return new SourceUpdatesDailyPoint(
            data?.date ?? "",
            data?.newItemCount ?? 0,
            data?.jsonDataChangedItemCount ?? 0,
            data?.attributesChangedItemCount ?? 0,
            data?.recentAttributesChangedItemCount ?? 0,
            data?.affectedItemCount ?? 0
        );
    }
}

export default SourceUpdatesDailyPoint;
